import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import FormError from '../../../errors/FormError';
import { FormResponseErrorType } from '../../../enums/FormResponseErrorType';
import { SonApiResponse } from '../../../../../../types/api/SonApiResponse';

type SendRequestProps = {
  payload: any;
  url: string;
  checkPageExists?: boolean;
  validateResponseStatus?: (status: number) => boolean;
};

/**
 * <Form checkPageExists ...
 *
 * will check the returned data.url for existence.
 * backend will return ok if API call to create page is done,
 * but may take a while until all services synced.
 *
 * this is to just simple and quickly check if we can show or redirect to a newly created page
 * */
const checkIfNewlyCreatedPageAlreadyExists = async (response: AxiosResponse<SonApiResponse>) => {
  const { data, status } = response;
  if (status >= 200 && status < 300 && data && data.url) {
    let pageExists;
    try {
      await axios.get(data.url);
      pageExists = true;
    } catch {
      pageExists = false;
    }
    return pageExists;
  }
};

const sendRequest = async ({ payload, url, checkPageExists, validateResponseStatus }: SendRequestProps) => {
  const payloadHasFile = payload && payload.values().some((entry: any) => entry instanceof File);

  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': payloadHasFile
        ? 'multipart/form-data'
        : // using url encoding to be conform with browser behaviour when no javascript is available
          'application/x-www-form-urlencoded',
    },
  };

  if (validateResponseStatus) {
    config.validateStatus = validateResponseStatus;
  }

  const DelayPromise = new Promise(resolve => {
    setTimeout(resolve, 1000);
  });
  const results = await Promise.all([
    axios.post<SonApiResponse>(url, payloadHasFile ? payload : new URLSearchParams(payload), config),
    DelayPromise,
  ]);

  if (results[0]?.status === 404) {
    throw new FormError(FormResponseErrorType.GENERIC_ERROR);
  }

  if (checkPageExists && !(await checkIfNewlyCreatedPageAlreadyExists(results[0]))) {
    throw new FormError(FormResponseErrorType.PAGE_NOT_EXISTS);
  }

  return results[0];
};

export default sendRequest;
